import createSagaMiddleware from "@redux-saga/core"
import { configureStore } from "@reduxjs/toolkit"
import rootReducer from "./reducers/rootReducer"
import rootSaga from "./saga/rootSaga"


const sagaMiddleware = createSagaMiddleware()

export default configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) => getDefaultMiddleware({thunk: false, serializableCheck: false}).concat(sagaMiddleware),
})

sagaMiddleware.run(rootSaga)
